export default function CsharpConstants() {
  return (
    <h2>Csharp Constants</h2>
  );
}
